import Document from 'components/Icons/Document';
import InboxIcon from 'components/Icons/InboxIcon';
import InboxSelectedIcon from 'components/Icons/InboxSelectedIcon';
import ManageClinicIcon from 'components/Icons/ManageClinicIcon';
import MessageIcon from 'components/Icons/MessageIcon';
import MessageSelectedIcon from 'components/Icons/MessageSelectedIcon';
import PatientIcon from 'components/Icons/PatientIcon';
import PatientSelectedIcon from 'components/Icons/PatientSelectedIcon';
import PatientsRequestSelected from 'components/Icons/PatientsRequestSelected';
import PatientsRequestsIcon from 'components/Icons/PatientsRequestsIcon';
import { ScribeIcon } from 'components/Icons/Scribe';
import { ScribeSelectedIcon } from 'components/Icons/ScribeSelectedIcon';
import SelectedDocument from 'components/Icons/SelectedDocument';
import SettingIcon from 'components/Icons/SettingIcon';
import SettingSelectedIcon from 'components/Icons/SettingSelectedIcon';
import NotFound from 'pages/404';
import AccountInfo from 'pages/Account/AccountInfo';
import Assistant from 'pages/Account/Assistant';
import ChangePassword from 'pages/Account/ChangePassword';
import ChangePin from 'pages/Account/ChangePin';
import Library from 'pages/Account/Library';
import TextMacros from 'pages/Account/TextMacros';
import ConfirmPassword from 'pages/Auth/ConfirmPassword';
import OtpVerification from 'pages/Auth/OtpVerification';
import BioMetricLock from 'pages/BioMetricLock';
import ClinicChat from 'pages/ClinicChat';
import RoleLogin from 'pages/RoleLogin';
// import MessageChat from 'pages/MessageChat';
import React, { lazy } from 'react';

const UserLogin = lazy(() => import('../pages/Auth/index'));
const VerifyOtp = lazy(() => import('../pages/Auth/VerifyOtp'));
const ForgotPassword = lazy(() => import('../pages/Auth/ForgotPassword'));
const PinScreen = lazy(() => import('../pages/Auth/PinScreen'));
const SetNewPin = lazy(() => import('../pages/Auth/SetNewPin'));
const VerifyPin = lazy(() => import('../pages/Auth/VerifyPin'));
const VerifyPatientInfo = lazy(() => import('../pages/Auth/VerifyPatientInfo'));
const DefaultScreen = lazy(() => import('../pages/DefaultScreen/index'));
const Groups = lazy(() => import('../pages/Groups/index'));
const Users = lazy(() => import('../pages/Users/index'));
const GroupMembers = lazy(() => import('../pages/GroupMembers/index'));
const Messaging = lazy(() => import('../pages/Messaging/index'));
const Settings = lazy(() => import('../pages/Settings/index'));
const Account = lazy(() => import('../pages/Account/index'));
const UsersAvailability = lazy(
  () => import('../pages/UsersAvailability/index')
);
const Dashboard = lazy(() => import('../pages/Dashboard/index'));
const Patients = lazy(() => import('../pages/Patients/index'));
const Inbox = lazy(() => import('../pages/Inbox/index'));
const PatientRequests = lazy(() => import('../pages/PatientRequests/index'));
const PatientDocuments = lazy(() => import('../pages/PatientDocuments/index'));

const MobileStarter = lazy(() => import('../pages/MobileStarter/index'));
const MobileNotifications = lazy(
  () => import('../pages/MobileNotifications/index')
);
const LoginAs = lazy(() => import('../pages/Auth/LoginAs'));
const ManageClinic = lazy(() => import('../pages/ManageClinic/ManageClinic'));
const ManageClinicDetails = lazy(
  () => import('../pages/ManageClinic/ClinicDetails')
);

const AccountActivate = lazy(() => import('../pages/AccountActivation/index'));
const ScribeDashboard = lazy(() => import('../pages/ScribeDashboard/index'));
const PatinetSearch = lazy(() => import('../pages/PatientSearch/index'));
const storedRoles = localStorage.getItem('roles');
const userDetails: any = storedRoles ? JSON.parse(storedRoles) : null;

export const NavigationLinks = [
  {
    name: 'Leads',
    redirectLink: '/leads',
  },
  {
    name: 'Providers Details',
    redirectLink: '/provider-details',
  },
];

export const routes: { [key: string]: any } = {
  REDIRECTOR: {
    pathname: '/',
    title: 'Login',
    isPublic: true,
    element: <UserLogin />,
  },
  404: {
    pathname: '*',
    title: 'Not Found',
    isPublic: true,
    element: <NotFound />,
  },
  LOGIN: {
    pathname: '/login',
    title: 'Login',
    isPublic: true,
    element: <UserLogin />,
  },
  VERIFY_OTP: {
    pathname: '/verify-otp',
    title: 'Verify email',
    isPublic: true,
    element: <VerifyOtp />,
  },
  FORGOT_PASSWORD: {
    pathname: '/forgot-password',
    title: 'Forgot password',
    isPublic: true,
    element: <ForgotPassword />,
  },
  PIN_SCREEN: {
    pathname: '/pin-screen',
    title: 'Pin screen',
    isPublic: true,
    element: <PinScreen />,
  },
  SET_NEW_PIN: {
    pathname: '/set-new-pin',
    title: 'Set New Pin',
    isPublic: true,
    element: <SetNewPin />,
  },
  VERIFY_PIN: {
    pathname: '/verify-pin',
    title: 'Verify Pin',
    isPublic: true,
    element: <VerifyPin />,
  },
  VERIFY_PATIENT_INFO: {
    pathname: '/verify-patient-info',
    title: 'Verify Patient Details',
    isPublic: true,
    element: <VerifyPatientInfo />,
  },
  CONFIRM_PASSWORD: {
    pathname: '/confirm-password',
    title: 'Confirm password',
    isPublic: true,
    element: <ConfirmPassword />,
  },
  MOBILESTARTER: {
    pathname: '/mobileapp/user/starter',
    title: 'Mobile Starter',
    isPublic: true,
    element: <MobileStarter />,
  },
  DASHBOARD: {
    pathname: '/dashboard',
    title: 'Dashboard',
    isPublic: false,
    element: <Dashboard />,
    authorizedRoles: ['practice_admin'],
  },
  USERS: {
    pathname: '/users',
    title: 'Users',
    isPublic: false,
    element: <Users />,
    authorizedRoles: ['practice_admin'],
  },
  GROUPS: {
    pathname: '/groups',
    title: 'Groups',
    isPublic: false,
    element: <Groups />,
    authorizedRoles: ['practice_admin'],
  },
  GROUP_Members: {
    pathname: '/groups/members',
    title: 'Groups Member',
    isPublic: false,
    element: <GroupMembers />,
    authorizedRoles: ['practice_admin'],
  },
  USERS_AVAILABILITY: {
    pathname: '/users-availability',
    title: 'Users Availability',
    isPublic: false,
    element: <UsersAvailability />,
    authorizedRoles: ['practice_admin'],
  },
  MESSAGING: {
    pathname: '/messaging',
    title: 'Messaging',
    isPublic: false,
    element: <Messaging />,
  },
  CHAT: {
    pathname: '/chat',
    title: 'Clinic Chat',
    isPublic: false,
    element: <ClinicChat />,
  },
  SETTINGS: {
    pathname: '/settings',
    title: 'Settings',
    isPublic: false,
    element: <Settings />,
    authorizedRoles: ['practice_admin'],
  },
  ACCOUNT: {
    pathname: '/account',
    title: 'Account',
    isPublic: false,
    element: <Account />,
  },
  LOGOUT: {
    pathname: '/logout',
    title: 'Logout',
    isPublic: false,
    element: <Users />,
    authorizedRoles: [],
  },
  DEFAULT_SCREEN: {
    pathname: '/default-screen',
    title: 'Default Screen',
    isPublic: true,
    element: <DefaultScreen />,
    authorizedRoles: [],
  },
  OTP_VERIFICATION: {
    pathname: '/otp-verification',
    title: 'Otp Verification',
    isPublic: true,
    element: <OtpVerification />,
  },
  // PATIENTS: {
  //   pathname: '/patients',
  //   title: 'Patients',
  //   isPublic: false,
  //   element: <Patients />,
  //   authorizedRoles: ['general_user', 'practice_admin'],
  // },
  INBOX: {
    pathname: '/inbox',
    title: 'Reception',
    isPublic: false,
    element: <Inbox />,
    authorizedRoles: ['general_user', 'practice_admin'],
  },
  REQUESTS: {
    pathname: '/requests',
    title: 'Requests',
    isPublic: false,
    element: <PatientRequests />,
    authorizedRoles: ['patient'],
  },
  DOCUMENTS: {
    pathname: '/documents',
    title: 'Documents',
    isPublic: false,
    element: <PatientDocuments />,
    authorizedRoles: ['patient'],
  },
  MOBILE_NOTIFICATIONS: {
    pathname: '/mobile-notifications',
    title: 'Notifications',
    isPublic: false,
    element: <MobileNotifications />,
  },
  BIO_METRIC: {
    pathname: '/bio-metric/info',
    title: 'BioMetrics',
    isPublic: false,
    element: <BioMetricLock />,
  },
  ROLE_LOGIN: {
    pathname: '/select-role',
    title: 'Super Admin',
    isPublic: true,
    element: <RoleLogin />,
  },
  LOGIN_AS: {
    pathname: '/login-as',
    title: 'Login as',
    isPublic: true,
    element: <LoginAs />,
  },
  MANAGE_CLINICS: {
    pathname: '/manage-clinic',
    title: 'Manage clinic',
    isPublic: false,
    element: <ManageClinic />,
    authorizedRoles: ['super_admin'],
  },
  MANAGE_CLINICS_DETAIL: {
    pathname: '/clinic-detail',
    title: 'Clinic details',
    isPublic: false,
    element: <ManageClinicDetails />,
    authorizedRoles: ['super_admin'],
  },
  ACCOUNT_ACTIVATE: {
    pathname: '/activate',
    title: 'Activate',
    isPublic: true,
    element: <AccountActivate />,
    authourizedRoles: [],
  },
  SEARCH: {
    pathname: '/scribe',
    title: 'Scribe',
    isPublic: false,
    element: <ScribeDashboard />,
    authourizedRoles: ['general_user', 'practice_admin'],
  },
  PATIENTS: {
    pathname: '/patients',
    title: 'PatientSearch',
    isPublic: false,
    element: <PatinetSearch />,
    authourizedRoles: ['general_user', 'practice_admin'],
  },
};

export const PracticeAdmin = [
  // {
  //   name: 'Dashboard',
  //   redirectLink: routes.DASHBOARD.pathname,
  //   isSelected: false,
  //   icon: <DashboardIcon />,
  //   selectedIcon: <DashboardSelectedIcon />,
  // },
  // {
  //   name: 'Users',
  //   redirectLink: routes.USERS.pathname,
  //   isSelected: false,
  //   icon: <UserIcon />,
  //   selectedIcon: <UserSelectedIcon />,
  // },
  // {
  //   name: 'Patients',
  //   redirectLink: routes.PATIENT_SEARCH.pathname,
  //   isSelected: false,
  //   icon: <PatientIcon />,
  //   selectedIcon: <PatientSelectedIcon />,
  // },
  {
    name: 'Patients',
    redirectLink: routes.PATIENTS.pathname,
    isSelected: false,
    icon: <PatientIcon />,
    selectedIcon: <PatientSelectedIcon />,
  },
  // {
  //   name: 'Groups',
  //   redirectLink: routes.GROUPS.pathname,
  //   isSelected: false,
  //   icon: <GroupIcon />,
  //   selectedIcon: <GroupSelectedIcon />,
  // },
  ...(userDetails?.scribe
    ? [
        {
          name: 'Scribe',
          redirectLink: routes.SEARCH.pathname,
          isSelected: false,
          icon: <ScribeIcon />,
          selectedIcon: <ScribeSelectedIcon />,
        },
      ]
    : []),
  {
    name: 'Reception',
    redirectLink: routes.INBOX.pathname,
    isSelected: false,
    icon: <InboxIcon />,
    selectedIcon: <InboxSelectedIcon />,
  },
  {
    name: 'Messaging',
    redirectLink: routes.MESSAGING.pathname,
    isSelected: false,
    icon: <MessageIcon />,
    selectedIcon: <MessageSelectedIcon />,
  },
  // {
  //   name: 'Internal Chat',
  //   redirectLink: routes.CHAT.pathname,
  //   isSelected: false,
  //   icon: <MessageIcon />,
  //   selectedIcon: <MessageSelectedIcon />,
  // },
  {
    name: 'Settings',
    redirectLink: routes.SETTINGS.pathname,
    isSelected: false,
    icon: <SettingIcon />,
    selectedIcon: <SettingSelectedIcon />,
  },
  // {
  //   name: 'Logout',
  //   redirectLink: routes.REDIRECTOR.pathname,
  //   isSelected: false,
  //   icon: <LogoutIcon />,
  // },
];

export const UserMenu = [
  {
    name: 'Messaging',
    redirectLink: routes.MESSAGING.pathname,
    isSelected: false,
    icon: <MessageIcon />,
    selectedIcon: <MessageSelectedIcon />,
  },
  // {
  //   name: 'Patients',
  //   redirectLink: routes.PATIENT_SEARCH.pathname,
  //   isSelected: false,
  //   icon: <PatientIcon />,
  //   selectedIcon: <PatientSelectedIcon />,
  // },
  {
    name: 'Patients',
    redirectLink: routes.PATIENTS.pathname,
    isSelected: false,
    icon: <PatientIcon />,
    selectedIcon: <PatientSelectedIcon />,
  },
  {
    name: 'Reception',
    redirectLink: routes.INBOX.pathname,
    isSelected: false,
    icon: <InboxIcon />,
    selectedIcon: <InboxSelectedIcon />,
  },
  // {
  //   name: 'Internal Chat',
  //   redirectLink: routes.CHAT.pathname,
  //   isSelected: false,
  //   icon: <MessageIcon />,
  //   selectedIcon: <MessageSelectedIcon />,
  // },
  ...(userDetails?.scribe
    ? [
        {
          name: 'Scribe',
          redirectLink: routes.SEARCH.pathname,
          isSelected: false,
          icon: <ScribeIcon />,
          selectedIcon: <ScribeSelectedIcon />,
        },
      ]
    : []),
  // {
  //   name: 'Requests',
  //   redirectLink: routes.REQUESTS.pathname,
  //   isSelected: false,
  //   icon: <PatientsRequestsIcon />,
  //   selectedIcon: <PatientsRequestSelected />,
  // },
];

export const PatientMenu = [
  // {
  //   name: 'Messaging',
  //   redirectLink: routes.MESSAGING.pathname,
  //   isSelected: false,
  //   icon: <MessageIcon />,
  //   selectedIcon: <MessageSelectedIcon />,
  //   id: 'PatientsMessagingDemo',
  // },
  {
    name: 'Messages',
    redirectLink: routes.REQUESTS.pathname,
    isSelected: false,
    icon: <PatientsRequestsIcon />,
    selectedIcon: <PatientsRequestSelected />,
    id: 'RequestDemo',
  },
  {
    name: 'Documents',
    redirectLink: routes.DOCUMENTS.pathname,
    isSelected: false,
    icon: <Document />,
    selectedIcon: <SelectedDocument />,
    id: 'Documents',
  },
];

export const DependentMenu = [
  {
    name: 'Requests',
    redirectLink: routes.REQUESTS.pathname,
    isSelected: false,
    icon: <PatientsRequestsIcon />,
    selectedIcon: <PatientsRequestSelected />,
    id: 'RequestDemo',
  },
  {
    name: 'Documents',
    redirectLink: routes.DOCUMENTS.pathname,
    isSelected: false,
    icon: <Document />,
    selectedIcon: <SelectedDocument />,
    id: 'Documents',
  },
];

export const SuperAdminMenu = [
  {
    name: 'Manage Clinic',
    redirectLink: routes.MANAGE_CLINICS.pathname,
    isSelected: false,
    icon: <ManageClinicIcon />,
    selectedIcon: <ManageClinicIcon />,
  },
];

export const getTranslatedAccountTabs = (t: Function) => {
  const PracticeAdmintabs = [
    { label: t('information'), content: <AccountInfo /> },
    {
      label: t('changePassword', { defaultValue: 'Change Password' }),
      content: <ChangePassword />,
    },
    {
      label: t('changePin', { defaultValue: 'Change Pin' }),
      content: <ChangePin />,
    },
    // {
    //   label: t('myAvailability', { defaultValue: 'My Availability' }),
    //   content: <Availablity />,
    // },
  ];
  const Usertabs = [
    {
      label: t('accountInfo', { defaultValue: 'Account Info' }),
      content: <AccountInfo />,
    },
    {
      label: t('changePassword', { defaultValue: 'Change Password' }),
      content: <ChangePassword />,
    },
    {
      label: t('changePin', { defaultValue: 'Change Pin' }),
      content: <ChangePin />,
    },
    // {
    //   label: t('myAvailability', { defaultValue: 'My Availability' }),
    //   content: <Availablity />,
    // },
  ];

  const Patienttabs = [
    {
      label: t('accountInfo', { defaultValue: 'Account Info' }),
      content: <AccountInfo />,
    },
    {
      label: t('changePassword', { defaultValue: 'Change Password' }),
      content: <ChangePassword />,
    },
    {
      label: t('changePin', { defaultValue: 'Change Pin' }),
      content: <ChangePin />,
    },
  ];
  const Dependenttabs = [
    {
      label: t('accountInfo', { defaultValue: 'Account Info' }),
      content: <AccountInfo />,
    },
    // {
    //   label: t('changePassword', { defaultValue: 'Change Password' }),
    //   content: <ChangePassword />,
    // },
    // {
    //   label: t('changePin', { defaultValue: 'Change Pin' }),
    //   content: <ChangePin />,
    // },
  ];

  const assistantTab = userDetails?.scribe
    ? [
        {
          label: t('assistant', { defaultValue: 'Assistant' }),
          content: <Assistant />,
        },
        {
          label: t('library', { defaultValue: 'Library' }),
          content: <Library />,
        },
        {
          label: t('TextMacros', { defaultValue: 'Text Macros' }),
          content: <TextMacros />,
        },
      ]
    : [];

  const PracticeAdmintab = [...PracticeAdmintabs, ...assistantTab];
  const Usertab = [...Usertabs, ...assistantTab];
  const Patienttab = [...Patienttabs, ...assistantTab];
  const Dependenttab = [...Dependenttabs, ...assistantTab];
  // If the user is not a scribe, return the default tabs
  return {
    PracticeAdmintab,
    Usertab,
    Patienttab,
    Dependenttab,
  };
};

export const routeKey = Object.assign(
  {},
  // eslint-disable-next-line @typescript-eslint/no-shadow
  ...Object.keys(routes).map((routeKey) => ({
    [routes[routeKey].pathname]: routeKey,
  }))
);

export const pageDetails = routes[routeKey[window.location.pathname]];
